import resume from '../assets/pdf/resume.pdf'
import boss from '../assets/img/boss.jpg'
export const headerData = {
    name: 'Virsail Mbagaya',
    title: "Sofware Developer",
    desciption:"The future belongs to us who believe in the beauty of our  dreams.Everyone is a genius so be the change you wish to see in the world.",
    image: boss,
    resumePdf: resume
}
